module.exports = __webpack_public_path__ + "logo-dw.png?93254ded649a95a7edc43a4fa7c444ea";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-dw.png
// module id = 205
// module chunks = 0